import { PrivacyPolicy } from '../../policies/privacy-policy/privacy-policy';

export const PrivacyPage = () => <PrivacyPolicy />;
